import { render, staticRenderFns } from "./action-subscription.vue?vue&type=template&id=72a0a53a&"
import script from "./action-subscription.vue?vue&type=script&lang=js&"
export * from "./action-subscription.vue?vue&type=script&lang=js&"
import style0 from "./action-subscription.vue?vue&type=style&index=0&id=72a0a53a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports